import { ApiRestService } from '../_services/api-rest.service';
import { Component, OnInit } from '@angular/core';
import { Paginazione } from 'src/app/shared/models/paginazione';
import { ServerPaginationService } from 'src/app/shared/_services/server-pagination.service';
import { environment } from 'src/environments/environment';
import {Corriere} from "../Models/Corriere";
import {ClassicType} from "../../shared/models/ClassicType";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {CorriereEditComponent} from "../corriere-edit/corriere-edit.component";

@Component({
  selector: 'app-Corrieri',
  templateUrl: './Corrieri.component.html'
})
export class CorrieriComponent implements OnInit {

  Lista: Corriere[] = [];
  Selected: Corriere = null;
  submittedricerca = false;
  editable: boolean = false;
  showaddform: boolean = false;
  titolo = environment.CorrieriLabel;
  /**************************************
        Variabili paginazione
  **************************************/
  page = 1;
  pageSize = 50;
  pagesizeserver = 4 // pagine da precaricare da lserver
  collectionSize = 0; // numero totale di elementi nell'array
  newpagegenerated = 0; // pagina per cui è stata fatta la richiesta al server
  Tipi: ClassicType[] = [];
  eliminati: boolean;

  constructor (
    private ApiRestService: ApiRestService,
    private paginationService: ServerPaginationService,
    private ngbModal: NgbModal,
  ) {
  }

  ngOnInit() {
    this.ApiRestService.TipiCorriere().subscribe(data=> this.Tipi = data )
    this.refreshTable(1);
  }

  sizeChanged() {
    this.refreshTable(1);
  }

  Search() {
    this.submittedricerca = true;
    this.refreshTable(1);
    this.submittedricerca = false;
  }

  edit(item?: Corriere) {
    if(!item)
      item = new Corriere()
    item.tipiObject = item?.tipiObject ?? [];

    let editModal = this.ngbModal.open(CorriereEditComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<CorriereEditComponent>editModal.componentInstance).Item = item ;
    (<CorriereEditComponent>editModal.componentInstance).updated.subscribe(data=> {this.refreshTable(1)});
  }

  delete(value: Corriere){
    if(value && value.id){
      if (confirm("Sicuro di voler eliminare questo elemento dalla lista?")) {
        this.ApiRestService.DeleteCorriere(value).subscribe(() => this.refreshTable(1));
      }
    }
    else if(value) {
      var indx = this.Lista.findIndex(x => x === value)
      this.Lista.splice(indx,1);
    }
  }

  getPage(page: number) {
    this.page = this.paginationService.paginadellalista(page, this.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.newpagegenerated, this.pagesizeserver);
    if ((pagetosend - 1) % this.pagesizeserver === 0) {
      this.newpagegenerated = page;
      this.refreshTable(pagetosend);
    }
  }
  refreshTable(page) {
    if(this.eliminati)
      this.ApiRestService.getCorrieriAll(new Paginazione((page - 1) / this.pagesizeserver + 1, this.pagesizeserver * this.pageSize)).subscribe(items => {
        if (items !== null && items !== undefined) {
          this.Lista = items.data;
          this.collectionSize = items.total;
          this.Selected = null;
        }
      });
    else
      this.ApiRestService.getCorrieriList(new Paginazione((page - 1) / this.pagesizeserver + 1, this.pagesizeserver * this.pageSize)).subscribe(items => {
        if (items !== null && items !== undefined) {
          this.Lista = items.data;
          this.collectionSize = items.total;
          this.Selected = null;
        }
      });
  }
  renew(item: Corriere) {
    this.ApiRestService.RestoreCorriere(item).subscribe(() => this.refreshTable(1));
  }

  MostraEliminati() {
    this.eliminati = !this.eliminati;
    this.refreshTable(1);
  }
}

